import type {
  CalendarDaily,
  SalesInfo,
  SalesMarket,
  SalesProduct,
  SalesStore,
  SettleInfo,
} from '@/types/statistics';
import { SalesInfoInitial, SettleInfoInitial } from '@/types/statistics';

export interface StatisticsCalendarMonthCacheValue {
  salesInfo: SalesInfo;
  settleInfo: SettleInfo;
  calendarDailyList: CalendarDaily[];
}

export interface StatisticsPeriodDetailMonthCacheValue {
  salesMarketList: SalesMarket[];
  salesProductList: SalesProduct[];
  salesStoreList: SalesStore[];
}

interface StatisticsCalendarMonthResponseItem {
  SalesInfo?: SalesInfo;
  SettleInfo?: SettleInfo;
  CalendarDailyList?: CalendarDaily[];
}

interface StatisticsPeriodDetailMonthResponseItem {
  SalesMarketList?: SalesMarket[];
  SalesProductList?: SalesProduct[];
  SalesStoreList?: SalesStore[];
}

export const getStatisticsMonthCacheKey = (dateString: string) => dateString.slice(0, 7);

export const createStatisticsCalendarMonthCacheValue = (
  monthlyStatistics?: StatisticsCalendarMonthResponseItem,
): StatisticsCalendarMonthCacheValue => ({
  salesInfo: monthlyStatistics?.SalesInfo ?? SalesInfoInitial,
  settleInfo: monthlyStatistics?.SettleInfo ?? SettleInfoInitial,
  calendarDailyList: monthlyStatistics?.CalendarDailyList ?? [],
});

export const createStatisticsPeriodDetailMonthCacheValue = (
  monthlyStatistics?: StatisticsPeriodDetailMonthResponseItem,
): StatisticsPeriodDetailMonthCacheValue => ({
  salesMarketList: monthlyStatistics?.SalesMarketList ?? [],
  salesProductList: monthlyStatistics?.SalesProductList ?? [],
  salesStoreList: monthlyStatistics?.SalesStoreList ?? [],
});
